import { ApolloError, DocumentNode, gql } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { GraphQLAlertMetric } from '../types';

const queryAlertMetrics = gql`
  query getAnalyticsMetrics($messageMedium: MessageMediumDefinition, $page: Page) {
    analyticsMetrics(messageMedium: $messageMedium, page: $page) {
      metricName
      valueType
      mediums
    }
  }
`;

type UseAlertMetricsQueryResponse = {
  errorMessage?: ApolloError;
  hasError: boolean;
  isLoading: boolean;
  results: GraphQLAlertMetric[];
};

export const useAlertMetricsQuery = (
  options?: Record<string, any>,
  query: DocumentNode = queryAlertMetrics,
): UseAlertMetricsQueryResponse => {
  const queryOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      ...options,
    }),
    [options],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
  } = useGraphql(query, queryOptions);

  const results = data?.analyticsMetrics ?? {};

  return {
    errorMessage,
    hasError,
    isLoading,
    results,
  };
};
